import fetch from "../../utils/fetch";

export function bindPlate(params) {
  return fetch({
    url: "/webApi/encrypt/platenumberUser/wxBindPlatenumber",
    method: "POST",
    data: params
  });
}
export function getXcxParkinglotInfo(params) {
  return fetch({
    url: "/webApi/encrypt/park/info",
    method: "POST",
    isEncrypt: true,
    merId: "10002211252",
    data: params
  });
}

export function relievePlate(params) {
    console.log(params,'params');
  return fetch({
    url: "/webApi/encrypt/platenumberUser/wxRelievePlate",
    method: "POST",
    isEncrypt: true,
    merId: "10002211252",
    data: params
  });
}

export function plateList(params) {
  return fetch({
    url: "/webApi/encrypt/platenumberUser/userPlatenumberList",
    method: "POST",
    isEncrypt: true,
    merId: "10002211252",
    data: params
  });
}
